import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const styles = () =>
  ({
    customBadge: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      borderRadius: "20px",
      height: "24px",
      maxWidth: "148px",
      padding: "6px 16px",
      width: "fit-content",
      whiteSpace: "nowrap",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Manrope",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: "0.5px",
    },
  } as const);

interface ICustomBadgeProps {
  backgroundColor?: string;
}

export const CustomBadge = styled("div")(({ backgroundColor }: ICustomBadgeProps) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  backgroundColor: backgroundColor || colors.success50,
  borderRadius: "20px",
  height: "24px",
  maxWidth: "148px",
  padding: "6px 16px",
  width: "fit-content",
  whiteSpace: "nowrap",
}));

interface ITextValue {
  textColor?: string;
}

export const TextValue = styled("span")(({ textColor }: ITextValue) => ({
  color: textColor,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));
